const isTrue = (value) => value === true || value === 1 || value === '1' || value === 'true';
const isFalse = (value) => value === false || value === 0 || value === '0' || value === 'false';

export const getGrantedChannelJoinTeamId = (data, fallbackTeamId = null) => {
    const payload = data?.data ?? data;
    if (!payload || typeof payload !== 'object' || isFalse(data?.success)
        || isFalse(payload.success) || (payload.status !== undefined
            && !['true', '1', 'success', 'ok', 'granted'].includes(String(payload.status).trim().toLowerCase()))) {
        return null;
    }

    if (['waitlist', 'waiting_list', 'on_waiting_list', 'is_waiting_list', 'requires_approval',
        'approval_required', 'admin_approval_required', 'pending', 'is_pending', 'waitlisted',
        'waiting', 'is_waitlisted', 'pending_approval', 'is_pending_approval'].some((key) => isTrue(payload[key]))) {
        return null;
    }

    const statuses = ['membership_status', 'subscription_status', 'join_status']
        .map((key) => String(payload[key] || '').trim().toLowerCase())
        .filter(Boolean);
    if (statuses.some((status) => status !== 'granted')
        || ['1', '3'].includes(String(payload.approval_status ?? ''))
        || isFalse(payload.access_granted)) {
        return null;
    }
    if (!isTrue(payload.access_granted) && !statuses.includes('granted')) {
        return null;
    }

    const teamId = String(payload.team_id ?? fallbackTeamId ?? '').trim();
    const numericTeamId = Number(teamId);
    return /^[1-9]\d*$/.test(teamId) && Number.isSafeInteger(numericTeamId) ? numericTeamId : null;
};

export const channelProfileUrl = (teamId, baseUrl) => {
    const url = new URL(baseUrl);
    url.searchParams.set('team-id', String(teamId));
    return url.href;
};
